import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import common from '../common/index';

const state = {
  addOnGameData: {
    success: false,
    gameId: null,
    correctAnswers: null,
    payOutPoints: 0,
    riskPoints: 0,
  },
  addOnBonusGameData: {
    success: false,
    gameId: null,
    prizeType: null,
    gameType: null,
    achievementName: null,
  },
  challengePending: false,
  validRedirectionToPendingRequestPage: false,
  challengeInfo: {
    challengingStickerIcon: null,
    challengedMsisdn: null,
    challengingMsisdn: null,
    challengedUsername: null,
    challengedLevel: null,
    challengingUsername: null,
    challengedAvatar: null,
    challengingAvatar: null,
    challengingLevel: null,
    forRematchHomeScore: null,
    forRematchAwayScore: null,
    forRematchIsHome: false,
    opponentIsBot: false,
  },
  gameStateEnumForResumeGame: null,
  numberOfQuestionsPerRound: 0,
  transitionOnlyForSearchingToOpponent: false,
  gamePending: false,
  gameInProgress: false,
  gameIsResuming: false,
  gameID: null,
  playersDetails: {
    homePlayerMSISDN: '',
    homePlayerUsername: '',
    homePlayerAvatar: null,
    homePlayerLevel: 0,
    awayPlayerMSISDN: '',
    awayPlayerUsername: '',
    awayPlayerAvatar: null,
    awayPlayerLevel: 0,
  },
  finalRoundNumber: common.state.lastRandomRound,
  currentThemeChooserMSISDN: '',
  currentRoundNumber: 1,
  currentQuestionNumber: 0,
  correctAnswerID: -1,
  currentRoundWinnerMSISDN: '',
  currentRoundWinnerUsername: '',
  gameFinished: false,
  gameWinnerMSISDN: '',
  gameWinnerUsername: '',
  userLeveledUp: false,
  // home player's game data
  homePlayerLevel: 0,
  homePlayerLevelUpBonusPoints: 0,
  homePlayerCurrentThemes: [],
  homePlayerCurrentSelectedTheme: null,
  homePlayerRoundScore: 0,
  homePlayerRoundAnswerTime: 0,
  homePlayerRoundIsWinner: false,
  homePlayerCheatHelpUsed: false,
  homePlayerFiftyFiftyHelpUsed: false,
  homePlayerQuestionDTO: null,
  homePlayerAnswer: '',
  homePlayerQuestionAnswerTime: 0,
  homePlayerCorrectAnswersCSSClasses: [],
  // home player's post game points
  homePlayerCorrectAnswersPoints: 0,
  homePlayerRoundVictoriesPoints: 0,
  homePlayerGameVictoryPoints: 0,
  homePlayerTotalEarnedPoints: 0,
  homePlayerCurrentLevel: 0,
  homePlayerGameWinsToLevelUp: 0,
  homePlayerGamesWon: 0,
  homePlayerGamesEarned: 0,
  // away player's game data
  awayPlayerLevel: 0,
  awayPlayerLevelUpBonusPoints: 0,
  awayPlayerCurrentThemes: [],
  awayPlayerCurrentSelectedTheme: null,
  awayPlayerRoundScore: 0,
  awayPlayerRoundAnswerTime: 0,
  awayPlayerRoundIsWinner: false,
  awayPlayerCheatHelpUsed: false,
  awayPlayerFiftyFiftyHelpUsed: false,
  awayPlayerQuestionDTO: null,
  awayPlayerAnswer: '',
  awayPlayerQuestionAnswerTime: 0,
  awayPlayerCorrectAnswersCSSClasses: [],
  // away player's post game points
  awayPlayerCorrectAnswersPoints: 0,
  awayPlayerRoundVictoriesPoints: 0,
  awayPlayerGameVictoryPoints: 0,
  awayPlayerTotalEarnedPoints: 0,
  awayPlayerCurrentLevel: 0,
  awayPlayerGameWinsToLevelUp: 0,
  awayPlayerGamesWon: 0,
  awayPlayerGamesEarned: 0,
  registrationPoints: {},
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};




// WEBPACK FOOTER //
// ./src/store/modules/game/index.js